import VacancyCandidatesEmptyState from './VacancyCandidatesEmptyState.component';

export default VacancyCandidatesEmptyState;
